var map = {
	"./4less.png": 220,
	"./EBM Whitepaper.pdf": 4158,
	"./Line_l.png": 9032,
	"./Polygon.png": 7753,
	"./Symbol.png": 5399,
	"./about.png": 8748,
	"./about2.png": 1764,
	"./about3.png": 9245,
	"./about4.png": 98,
	"./arrow_p.png": 3609,
	"./b_line.png": 9496,
	"./bbb.png": 6021,
	"./benefit_bg.png": 2490,
	"./benefits.png": 6039,
	"./bg-banner.png": 9083,
	"./brand1.png": 351,
	"./brand2.png": 8884,
	"./brand3.png": 13,
	"./brand4.png": 4642,
	"./brand5.png": 8795,
	"./buy_crypto.png": 6787,
	"./bxs_up-arrow.png": 4292,
	"./c1.png": 3424,
	"./c2.png": 5768,
	"./c3.png": 3633,
	"./c5.png": 935,
	"./card_bg_t.png": 5302,
	"./ebm.mp4": 7920,
	"./election1.png": 7741,
	"./election2.png": 7062,
	"./election3.png": 5151,
	"./election4.png": 6496,
	"./election_bg.png": 7010,
	"./election_bg_2.png": 3645,
	"./email.png": 3,
	"./faq.png": 9011,
	"./footer_logo.png": 6274,
	"./global-business.png": 4831,
	"./hero_iamge.png": 5757,
	"./hero_right_image.png": 4962,
	"./i.fas.png": 814,
	"./ic_sharp-discord.png": 9885,
	"./iconoir_telegram.png": 4836,
	"./left_arrow.png": 4510,
	"./left_image.png": 3822,
	"./line_v.png": 5122,
	"./logo.png": 2806,
	"./mash_image.png": 3830,
	"./mash_right.png": 1027,
	"./mesh-testimonials-blockchain.png": 5668,
	"./pikaso_texttoimag.png": 49,
	"./player.png": 8684,
	"./plus.png": 5307,
	"./profile.png": 5572,
	"./right_arrow.png": 4543,
	"./right_image.png": 2575,
	"./road.png": 4961,
	"./road_map_bg.png": 982,
	"./stake4pie.png": 5283,
	"./team_bg.png": 1276,
	"./token.png": 9860,
	"./token_bg.png": 6368,
	"./tokenomics_bg.png": 495,
	"./tokens.png": 3685,
	"./tokens_b.png": 8854,
	"./top_arrow.png": 3780,
	"./twitter.png": 2662,
	"./video1.mp4": 2230,
	"./video2.mp4": 5529,
	"./video3.mp4": 1812,
	"./video4.mp4": 6087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;